export default __webpack_public_path__ + "static/media/image-ph-study-ranking-n-m@3x.fcb8aafe.webp";